module.exports = __webpack_public_path__ + "img/1alB-u-gu.32bc6c77.jpg";